/* The element reconnects after collection filtering, sorting and pagination. */
if (!customElements.get('nuve-collection-swatches')) {
  customElements.define('nuve-collection-swatches', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', (event) => this.selectSwatch(event), options);
      this.addEventListener('pointerover', (event) => {
        const swatch = event.target.closest('.nuve-collection-swatch');
        if (swatch?.dataset.image && !swatch.hasAttribute('data-linked-product')) {
          const preload = new Image();
          preload.src = swatch.dataset.image;
        }
      }, options);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    selectSwatch(event) {
      const swatch = event.target.closest('.nuve-collection-swatch');
      if (!swatch || !this.contains(swatch) || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          swatch.hasAttribute('data-linked-product')) return;

      const card = this.closest('product-card');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();

      this.querySelectorAll('.nuve-collection-swatch').forEach((item) => {
        if (item === swatch) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });

      const variantUrl = new URL(swatch.href, location.origin);
      card.querySelectorAll('a.product-card__media, a.product-title').forEach((link) => {
        link.href = variantUrl.pathname + variantUrl.search;
      });
      const modal = card.querySelector('quick-buy-modal');
      if (modal) {
        const handle = card.getAttribute('handle');
        modal.setAttribute('handle', handle + variantUrl.search);
      }

      // Change both images, so the previous colour cannot reappear on hover.
      // Leave the existing photo visible if a variant has no photo or fails to load.
      const requestedImage = swatch.dataset.image;
      this.requestedImage = requestedImage;
      if (!requestedImage) return;
      const preload = new Image();
      preload.onload = () => {
        if (!this.isConnected || this.requestedImage !== requestedImage) return;
        card.querySelectorAll('.product-card__image--primary, .product-card__image--secondary').forEach((image) => {
          image.removeAttribute('srcset');
          image.src = requestedImage;
          image.alt = swatch.dataset.imageAlt || '';
        });
      };
      preload.src = requestedImage;
    }
  });
}
